import * as React from "react";
import { useCountryValue } from "../Contexts/CountryContext";
export var Price = function () {
  var state = useCountryValue()[0];
  var phoneInfo = state.callData.countries[state.country];
  // const {info} = phoneInfo;
  var info = "2,49 €/Min";
  return /*#__PURE__*/React.createElement("p", {
    className: "price c-phonesex-banner__price"
  }, info);
};